// import TronWeb from "tronweb";
import { sha3_256 } from 'js-sha3';
const { fromHex } = require("tron-format-address");

class WalletGenerator {

    generateWalletAddress(phone) {
        const hexHash = sha3_256(phone)
        const ethereumAddress = "0x" + hexHash.slice(hexHash.length - 40)
        return fromHex(ethereumAddress);
    }

}

export default new WalletGenerator()